import moment from "moment";
import React, {FC, memo} from "react";
import i18n from "../../../services/i18n";

type TimeInputErrorProps = {
    startDateTime: Date;
    endDateTime: Date;
    style?: React.CSSProperties;
    setTimeError?: (error: string | undefined) => void;
};

const TimeInputError: FC<TimeInputErrorProps> = ({
    startDateTime,
    endDateTime,
    style,
    setTimeError,
}) => {
    const startTime = moment(startDateTime);
    const endTime = moment(endDateTime);

    const compareStartTime = moment()
        .hours(startTime.hours())
        .minutes(startTime.minutes());
    const compareEndTime = moment()
        .hours(endTime.hours())
        .minutes(endTime.minutes());

    const duration = moment.duration(compareEndTime.diff(compareStartTime));
    const hours = duration.asHours();

    if (hours < 0) {
        setTimeError?.("error");

        return (
            <div
                style={{
                    ...style,
                    color: "red",
                    padding: "5px 3px",
                    marginBottom: 10,
                    lineHeight: 1.1,
                }}
            >
                {i18n.containers.courses.CourseCreate.courseEndDateTime.endTimeBeforeStart()}
            </div>
        );
    }

    setTimeError?.(undefined);

    return null;
};

export default memo(TimeInputError);
